import React from 'react';
import { Card, Box, Typography } from '@mui/material';

const DetailsCard = ({
  title,
  children,
  actions,
  sx = {},
  headerSx = {},
  contentSx = {},
  hidden = false,
}) => {
  return (
    <Card sx={{ mb: 3, ...sx }}>
      {(title || actions) && !hidden && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: 50,
            px: 2,
            borderBottom: 1,
            borderColor: 'divider',
            ...headerSx,
          }}
        >
          {title && (
            <Typography variant="h6">
              {title}
            </Typography>
          )}
          {actions}
        </Box>
      )}

      {/* Content */}
      <Box sx={{ p: 2, ...contentSx }}>
        {children}
      </Box>
    </Card>
  );
};

export default DetailsCard;